export const tr = {
    hello: 'Merhaba',

}
